export default __webpack_public_path__ + "static/media/drop-down.61c768c5.svg";